var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVacuum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 296.96,
    y: 42.165,
    style: {
      fill: "#58575D"
    },
    width: 36.141,
    height: 60.235
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F8E99B"
    },
    points: "158.419,295.153 266.842,90.353 375.266,90.353 339.125,475.859 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6E27D"
    },
    points: "375.266,90.353 266.842,90.353 266.841,90.354 266.841,403.576 339.125,475.859 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797781"
    },
    d: "M158.419,439.718V295.152c119.761,0.001,180.706,80.906,180.706,180.707 c0,19.96-16.182,36.141-36.141,36.141h-96.376"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58575D"
    },
    d: "M266.841,325.09V512h36.142c19.96,0,36.141-16.182,36.141-36.141 C339.125,412.88,314.845,357.436,266.841,325.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88888F"
    },
    d: "M164.442,439.718h-36.141V114.447c0-56.463,45.937-102.4,102.4-102.4h204.8v36.141h-204.8 c-36.535,0-66.259,29.724-66.259,66.259V439.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F8F9"
    },
    d: "M13.854,512c0-53.227,43.149-96.376,96.376-96.376s96.376,43.149,96.376,96.376H13.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M13.854,512c0-53.227,43.149-96.376,96.376-96.376s96.376,43.149,96.376,96.376H13.854z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8F8F9"
    },
    cx: 242.748,
    cy: 475.859,
    r: 36.141
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.842,
    y: 12.047,
    style: {
      fill: "#797781"
    },
    width: 168.659,
    height: 36.141
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58575D"
    },
    d: "M468.028,0h-44.574v60.235h44.574c16.633,0,30.118-13.484,30.118-30.118S484.662,0,468.028,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M278.889,475.859c0-10.701-4.655-20.313-12.047-26.931v53.864 C274.234,496.171,278.889,486.56,278.889,475.859z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuum);
export default __webpack_public_path__ + "static/media/vacuum.f545f2e28efae1451877cfef74aa2bea.svg";
export { ForwardRef as ReactComponent };